import {
  CLEAR_LEADERBOARD_SUCCESS,
  GET_LEADERBOARD_POINTS,
  GET_LEADERBOARD_POINTS_FAILED,
  GET_LEADERBOARD_POINTS_SUCCESS,
  GET_LEADERBOARD_USERS_LIST_SUCCESS,
  GET_LEADERBOARD_USERS_POINTS_SUCCESS,
  HIDE_RESET_LEADERBOARD_MODAL,
  RESET_LEADERBOARD_FORM,
  SHOW_RESET_LEADERBOARD_MODAL,
} from "./actionTypes"

const INIT_STATE = {
  leaderboardPoints: [],
  isResetLeaderborardModalOpen: false,
  leaderboardUsersPoints: [],
  leaderboardUsersList: null,
  loading: false,
}

const Leaderboard = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEADERBOARD_POINTS:
      return {
        ...state,
        loading: true,
      }
    case GET_LEADERBOARD_POINTS_SUCCESS:
      return {
        ...state,
        leaderboardPoints: action.payload,
        loading: false,
      }
    case GET_LEADERBOARD_POINTS_FAILED:
      return {
        ...state,
        loading: false,
      }
    case CLEAR_LEADERBOARD_SUCCESS:
      return {
        ...state,
        leaderboardPoints: action.payload,
      }
    case SHOW_RESET_LEADERBOARD_MODAL:
      return {
        ...state,
        isResetLeaderborardModalOpen: true,
      }
    case HIDE_RESET_LEADERBOARD_MODAL:
      return {
        ...state,
        isResetLeaderborardModalOpen: false,
      }
    case GET_LEADERBOARD_USERS_POINTS_SUCCESS:
      return {
        ...state,
        leaderboardUsersPoints: action.payload,
      }
    case GET_LEADERBOARD_USERS_LIST_SUCCESS:
      return {
        ...state,
        leaderboardUsersList: action.payload,
      }
    case RESET_LEADERBOARD_FORM:
      return {
        ...state,
        leaderboardPoints: [],
        leaderboardUsersPoints: [],
        leaderboardUsersList: null,
      }
    default:
      return state
  }
}

export default Leaderboard
